import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/uxp-photoshop-zh-cn/uxp-photoshop-zh-cn/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="module-storage-folder" id="module-storage-folder"></a>
    <h1 {...{
      "id": "requireuxpstoragefolder"
    }}>{`require('uxp').storage.Folder`}</h1>
    <p>{`Represents a folder on a file system. You'll never instantiate this directly,
but will get it by calling `}<a parentName="p" {...{
        "href": "/uxp-photoshop-zh-cn/uxp/reference-js/Modules/uxp/Persistent%20File%20Storage/FileSystemProvider/#module-storage-filesystemprovider-gettemporaryfolder"
      }}>{`FileSystemProvider.getTemporaryFolder`}</a>{`,
`}<a parentName="p" {...{
        "href": "/uxp-photoshop-zh-cn/uxp/reference-js/Modules/uxp/Persistent%20File%20Storage/FileSystemProvider/#module-storage-filesystemprovider-getfolder"
      }}>{`FileSystemProvider.getFolder`}</a>{`,
or via `}<a parentName="p" {...{
        "href": "/uxp-photoshop-zh-cn/uxp/reference-js/Modules/uxp/Persistent%20File%20Storage/Folder/#module-storage-folder-getentries"
      }}>{`Folder.getEntries`}</a>{`.`}</p>
    <a name="module-storage-folder-isfolder" id="module-storage-folder-isfolder"></a>
    <h2 {...{
      "id": "isfolder"
    }}>{`isFolder`}</h2>
    <p>{`Indicates that this instance is a folder. Useful for type checking.`}</p>
    <a name="module-storage-folder-getentries" id="module-storage-folder-getentries"></a>
    <h2 {...{
      "id": "getentries"
    }}>{`getEntries()`}</h2>
    <p>{`Returns an array of entries contained within this folder.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<Array<Entry>>`}</inlineCode>{` - The entries within the folder.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const entries = await aFolder.getEntries();
const allFiles = entries.filter(entry => entry.isFile);
`}</code></pre>
    <a name="module-storage-folder-createentry" id="module-storage-folder-createentry"></a>
    <h2 {...{
      "id": "createentryname-options"
    }}>{`createEntry(name, options)`}</h2>
    <p>{`Creates an entry within this folder and returns the appropriate instance.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<File | Folder>`}</inlineCode>{` the created entry  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the name of the entry to create`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`any`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.type]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Symbol`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`types.file`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicates which kind of entry to create. Pass `}<a parentName="td" {...{
              "href": "/uxp-photoshop-zh-cn/uxp/reference-js/Modules/uxp/Persistent%20File%20Storage/Folder/"
            }}>{`Folder`}</a>{` to create a new folder. Note that if the type is file then this method just create a file entry object and not the actual file on the disk. The file actually gets created when you call for eg: write method on the file entry object.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.overwrite]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If `}<inlineCode parentName="td">{`true`}</inlineCode>{`, the create attempt can overwrite an existing file`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const myNovel = await aFolder.createEntry("mynovel.txt");
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const catImageCollection = await aFolder.createEntry("cats", {type: types.folder});
`}</code></pre>
    <a name="module-storage-folder-createfile" id="module-storage-folder-createfile"></a>
    <h2 {...{
      "id": "createfilename-options"
    }}>{`createFile(name, options)`}</h2>
    <p>{`Creates a File Entry object within this folder and returns the appropriate instance.
Note that this method just create a file entry object and not the actual file on the disk.
The file actually gets created when you call for eg: write method on the file entry object.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<File>`}</inlineCode>{` - the created file entry  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the name of the file to create.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`any`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.overwrite]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`If `}<inlineCode parentName="td">{`true`}</inlineCode>{`, the create attempt can overwrite an existing file`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const myNovelTxtFile = await aFolder.createFile("mynovel.txt");
`}</code></pre>
    <a name="module-storage-folder-createfolder" id="module-storage-folder-createfolder"></a>
    <h2 {...{
      "id": "createfoldername"
    }}>{`createFolder(name)`}</h2>
    <p>{`Creates a Folder within this folder and returns the appropriate instance.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<Folder>`}</inlineCode>{` - the created folder entry object  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the name of the folder to create.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const myCollectionsFolder = await aFolder.createFolder("collections");
`}</code></pre>
    <a name="module-storage-folder-getentry" id="module-storage-folder-getentry"></a>
    <h2 {...{
      "id": "getentryfilepath"
    }}>{`getEntry(filePath)`}</h2>
    <p>{`Gets an entry from within this folder and returns the appropriate instance.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<File | Folder>`}</inlineCode>{` the fetched entry.  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`filePath`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the name/path of the entry to fetch`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const myNovel = await aFolder.getEntry("mynovel.txt");
`}</code></pre>
    <a name="module-storage-folder-renameentry" id="module-storage-folder-renameentry"></a>
    <h2 {...{
      "id": "renameentryentry-newname-options"
    }}>{`renameEntry(entry, newName, options)`}</h2>
    <p>{`Renames an entry to a new name.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Promise<void>`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Entry`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the entry to rename`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`newName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the new name to assign`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`any`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options.overwrite]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`if `}<inlineCode parentName="td">{`true`}</inlineCode>{`, renaming can overwrite an existing entry`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`await myNovels.rename(myNovel, "myFantasticNovel.txt");
`}</code></pre>
    <a name="module-storage-folder-isfolder" id="module-storage-folder-isfolder"></a>
    <h2 {...{
      "id": "isfolder--boolean"
    }}>{`isFolder ⇒ `}<inlineCode parentName="h2">{`boolean`}</inlineCode></h2>
    <p>{`Checks if an entry is a folder. Safe to use if entry might be `}<inlineCode parentName="p">{`null`}</inlineCode>{` or
`}<inlineCode parentName="p">{`undefined`}</inlineCode>{`. Useful for type checking.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{` - if `}<inlineCode parentName="p">{`true`}</inlineCode>{`, the entry is a folder  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`entry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`any`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the entry to check`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      